export function isFilter(f) {
    return f && typeof f.apply === "function";
}
//# sourceMappingURL=tiles.codecs.interfaces.js.map